<template>
  <div id="admin-app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
#admin-app {
  height: 100vh;
}
</style>
